
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f92me", function(module, exports) {

$parcel$export(module.exports, "updateQRMenuText", function () { return $b0698673bf32ec26$export$fdb37755460c48a; });

var $4cbJT = parcelRequire("4cbJT");

var $5I4gX = parcelRequire("5I4gX");

var $dNpKm = parcelRequire("dNpKm");

var $f46qz = parcelRequire("f46qz");

var $4iCXN = parcelRequire("4iCXN");
function $b0698673bf32ec26$export$fdb37755460c48a(isShowMode = false) {
    const qrMenuItem = document.querySelector('#openQRreader .menu__item-text');
    if (qrMenuItem) qrMenuItem.textContent = isShowMode ? 'My Album Code' : 'QR Scanner';
}
(function initMenu() {
    const $menu = document.querySelector('.menu');
    const $menuList = document.querySelector('.menu__list');
    const $btnOpen = document.querySelector('.top-panel__button-menu');
    const $btnClose = document.querySelector('.menu__btn-close');
    const menuList = [
        {
            text: 'Registered Faces',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4cbJT))),
            isHidden: false,
            htmlId: 'selfies',
            href: (0, $4iCXN.pageRoutes).selfies
        },
        {
            text: 'QR Scanner',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dNpKm))),
            isHidden: false,
            htmlId: 'openQRreader',
            htmlClass: 'qr-btn'
        },
        {
            text: 'Terms and Conditions',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5I4gX))),
            isHidden: true,
            htmlId: 'privacy-link',
            href: (0, $4iCXN.pageRoutes).privacyPolicy
        },
        {
            text: 'FAQ',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5I4gX))),
            isHidden: false,
            href: (0, $4iCXN.pageRoutes).faq
        },
        {
            text: 'Support',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5I4gX))),
            isHidden: true,
            htmlClass: 'open-zendesk'
        }
    ];
    if ($btnOpen && $btnClose) {
        $btnOpen.addEventListener('click', ()=>{
            $menu.classList.remove('menu_hidden');
        });
        $btnClose.addEventListener('click', ()=>{
            $menu.classList.add('menu_hidden');
        });
    }
    if ($menu) {
        const template = menuList.map(({ text: text, icon: icon, isHidden: isHidden, href: href, htmlId: htmlId, htmlClass: htmlClass })=>{
            const classHidden = isHidden ? 'menu__item_hidden' : '';
            const customClass = htmlClass || '';
            const attrId = htmlId ? ` id="${htmlId}"` : '';
            const attrHref = href ? ` href="${href}"` : '';
            return `
      <a class="menu__item ${classHidden} ${customClass}"${attrId}${attrHref}>
        <img class="menu__item-icon" src="${icon}" alt="" />
        <div class="menu__item-text">${text}</div>
      </a>
    `;
        });
        $menuList.innerHTML = template.join('');
    }
})();
(function initCheckbox() {
    (0, $f46qz.onClickAll)('.checkbox', (event)=>{
        if (!(event.target.nodeName === 'A')) event.currentTarget.classList.toggle('checkbox_checked');
    });
})();
(function initBackBtn() {
    (0, $f46qz.onClickAll)('.behavior-go-back', ()=>{
        globalThis.history.go(-1);
    });
})();
(function initBtnGoHome() {
    (0, $f46qz.onClickAll)('.behavior-go-home', ()=>{
        globalThis.location.href = localStorage.getItem('home');
    });
})();
(function initBtnGoToCombos() {
    (0, $f46qz.onClickAll)('.behavior-go-combos', ()=>{
        (0, $4iCXN.redirectToPage).combos();
    });
})();

});
parcelRegister("4cbJT", function(module, exports) {
module.exports = $parcel$resolve("lyiIw");

});

parcelRegister("5I4gX", function(module, exports) {
module.exports = $parcel$resolve("erJTj");

});

parcelRegister("dNpKm", function(module, exports) {
module.exports = $parcel$resolve("2C9Nc");

});


var $eaccbe941fcd083c$exports = {};
$parcel$extendImportMap({
    "lyiIw": "menu-add-selfie.f5cac2ad.svg",
    "erJTj": "menu-help.51af0466.svg",
    "2C9Nc": "menu-show-qr.6315d4bd.svg"
});


parcelRequire("f92me");

//# sourceMappingURL=addons.fb65e0fb.js.map
